<template>
  <div class="question">
    <div class="info">
      <h3>{{ question.name }}</h3>
      <p>{{ question.created_at | formatdate }}</p>
    </div>
    <div class="q">
      <p>{{ question.question }}</p>
      <template v-if="question.answered && question.answer !== ''">
        <p><strong>Answer:</strong> {{ question.answer }}</p>
      </template>
    </div>
    <div class="actions">
      <template v-if="!question.answered">
        <div @click="answerQuestion = true">
          <i class="icon-chat-24" />
        </div>
      </template>
      <div @click="remove">
        <i class="icon-trash-24" />
      </div>
    </div>

    <portal to="modals">
      <modal :show="answerQuestion" @close="answerQuestion = false" class="auto-height" :title="`Answer question from ${question.name}`" :subtitle="question.question">
        <form class="p-a-4" @submit.prevent="answer">
          <form-input v-model="answerText" placeholder="Write your answer. Empty answer will mark question as answered" />
        </form>
        <template v-slot:footer>
          <div class="d-f f-w">
            <Button class="button" @click="answer">Answer</Button>
            <Button class="button red outline ml-a" @click="answerQuestion = false">Cancel</Button>
          </div>
        </template>
      </modal>
    </portal>
  </div>
</template>

<script>
export default {
  props: {
    question: {
      type: Object,
      required: true,
    },
  },
  computed: {
    /**
     * Return the current broadcast in store
     * @returns {?Object}
     */
    broadcast() {
      return this.$store.getters['Broadcast/current'];
    },
  },
  methods: {
    async answer() {
      const { answerText } = this;

      await this.$store.dispatch('Broadcast/answerQ', {
        id: this.broadcast.id,
        qid: this.question.id,
        answer: answerText,
      });

      this.answerQuestion = false;

      this.$emit('refetch', true);
    },
    /**
     * Delete message
     * @param {String} id
     */
    async remove() {
      const bool = await swal({
        title: 'Are you sure?',
        text: 'This will delete this question and it cannot be reversed.',
        icon: 'warning',
        buttons: true,
        dangerMode: true,
      });

      if (!bool) {
        return;
      }

      await this.$store.dispatch('Broadcast/deleteQ', { id: this.broadcast.id, qid: this.question.id });
    },
  },
  data() {
    return {
      answerQuestion: false,
      answerText: '',
    };
  },
};
</script>

<style lang="scss" scoped>
.question {
  align-items: center;
  background: #FFFFFF;
  box-shadow: 0 2px 4px 0 rgba(165,179,194,0.20), 0 0 1px 0 rgba(165,179,194,0.50);
  border-radius: 4px;
  border: 1px solid #EEF0F9;
  display: flex;
  overflow: hidden;
  width: 100%;
  margin-bottom: 10px;

  .info {
    flex: 1;
    padding: 16px 20px;
  }

  .q {
    flex: 5;
  }

  .actions {
    align-self: stretch;
    display: flex;

    & > div {
      align-items: center;
      border-left: 1px solid #EEF0F9;
      display: flex;
      padding: 0 12px;
      transition: color .3s;

      &:hover {
        cursor: pointer;
      }
    }

    i {
      font-size: 20px;
    }

    .gray {
      color: var(--color-cta-gray);
      pointer-events: none;
    }

    .blue {
      color: var(--color-cta-blue);
    }

    .red {
      color: var(--color-cta-red);
    }

    .red-hover:hover {
      color: var(--color-cta-red);
    }
  }
}
</style>
